<template>
  <nav class="navbar" id="top">
    <div class="navbar-brand">
      <router-link class="navbar-item" to="/">
        <img src="~@/assets/logo.png" class="logo" alt="The Home Depot Pro">
      </router-link>

      <!-- Location Logo -->
      <template v-if="isLoggedIn && !['ROOT', 'SupplyWorks'].includes(loggedUser.location)">
        <hr class="navbar-divider">
        <p class="navbar-item location-logo">
          <template v-if="loggedUser.locationLogo !== null">
            <img :src="loggedUser.locationLogo" />
          </template>
          <template v-else>
            <span>{{ loggedUser.location }}</span>
          </template>
        </p>
      </template>
      <!-- Menu on tablet -->
      <b-dropdown v-if="isLoggedIn" v-model="activeMenuItem" class="is-hidden-tablet">
        <button class="button is-primary" type="button" slot="trigger">
          <template>
            <b-icon :icon="iconActiveRoute"></b-icon>
            <span>{{ activeRoute }}</span>
          </template>
        </button>

        <b-dropdown-item v-for="item in menuItems" :key="item.name" :has-link="true">
          <router-link :key="item.name"
                       :to='item.route' :replace="true">
            <div class="media">
              <b-icon class="media-left" :icon="item.icon"></b-icon>
              <div class="media-content">
                <h3>{{ item.name }}</h3>
                <!-- <small>{{ item.description }}</small> -->
              </div>
            </div>
          </router-link>
        </b-dropdown-item>

        <hr class="dropdown-divider">
        <!-- <div class="navbar-item">
           <b-field label="Current Location">
            <b-select v-model.number="user.locationId" :loading="$loading.isLoading('getLocationsByUser')" :disabled="$loading.isLoading([ endpoint, 'getUser', 'getLocationsByUser' ])" placeholder="Select a location" expanded required>
              <option v-for="location in locations" :value="location.id" :key="location.id">
                {{ location.name }}
              </option>
            </b-select>
          </b-field>
        </div> -->
        <hr class="dropdown-divider">
        <b-dropdown-item @click="logOut">
          <div class="media">
            <b-icon class="media-left" icon="power"></b-icon>
            <div class="media-content">
              <h3>Log Out</h3>
            </div>
          </div>
        </b-dropdown-item>
      </b-dropdown>
    </div>

    <!-- Only Desktop -->
    <div v-if="isLoggedIn" class="navbar-menu is-hidden-mobile">
      <div class="navbar-end">
        <!-- Stats -->
        <p class="navbar-item is-hidden-mobile has-text-primary" style='width: 150px; text-align: center;'>Key Performance Indicators</p>
        <p v-if="$loading.isLoading('getReportKPI')" class="navbar-item is-hidden-mobile">
          Getting stats...
        </p>
        <p v-else v-for="(stat, i) in kpiStats" :key="stat.name" :class="{ 'has-text-primary': i === 3 }" class="navbar-item is-hidden-mobile">
          {{ i }} &nbsp;
          <b class="has-text-primary">
            {{ stat }}
          </b>
        </p>
        <!-- <pclass="navbar-item is-hidden-mobile has-text-primary" style='width: 150px; text-align: center;'>Current Location</p> -->
        <!-- <div class="navbar-item">
           <b-field label="Current Location">
            <b-select v-model.number="user.locationId" :loading="$loading.isLoading('getLocationsByUser')" :disabled="$loading.isLoading([ endpoint, 'getUser', 'getLocationsByUser' ])" placeholder="Select a location" expanded required>
              <option v-for="location in locations" :value="location.id" :key="location.id">
                {{ location.name }}
              </option>
            </b-select>
          </b-field>
        </div> -->
        <!-- Dropdown -->
        <b-dropdown hoverable position="is-bottom-left">
          <a class="navbar-item" slot="trigger">
            <span>{{ loggedUser.email }}</span>
            <b-icon icon="menu-down"></b-icon>
          </a>
          <!-- <b-dropdown-item has-link>
            <div class="field">
              <a @click="receiveEmailNotifications = !receiveEmailNotifications">
                <b-switch :value="receiveEmailNotifications">
                    Receive email notifications
                </b-switch>
              </a>
            </div>
          </b-dropdown-item>
          <hr class="dropdown-divider"> -->
          <b-dropdown-item has-link>
              <a @click="logOut">
                  <i class="mdi mdi-power"></i>
                  Log Out
              </a>
          </b-dropdown-item>
        </b-dropdown>
      </div>
    </div>
  </nav>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'TopNav',
  data() {
    return {
      user: {
        id: 0,
        locationId: null,
        roles: [{ id: null }],
        firstName: null,
        lastName: null,
        email: null,
        additionalEmailsArray: [],
        additionalEmails: null,
        additionalLocationsArray: [],
        additionalLocations: null
      },
      receiveEmailNotifications: false,
      activeMenuItem: true
    }
  },
  computed: {
    ...mapGetters({
      isRoutePublic: 'auth/isRoutePublic',
      isLoggedIn: 'auth/isLoggedIn',
      loggedUser: 'auth/loggedUser',
      menuItems: 'auth/menuItems',
      kpiStats: 'location/kpiStats',
      locations: 'location/locations'
    }),
    activeRoute() {
      return this.$route.name === null ? null : this.$route.name.split('.')[0]
    },
    iconActiveRoute() {
      let route =
        this.$route.name === null ? null : this.$route.name.split('.')[0]
      let item = this.menuItems.filter(x => x.name.slice(0, -1) === route)[0]
      return typeof item !== 'undefined' ? item.icon : ''
    }
  },
  methods: {
    ...mapActions('auth', ['logOut'])
  },
  created() {
    // Do not load any data is route is public
    if (this.isRoutePublic) return
    this.$store.dispatch('location/getLocationsByUser')
    // Get statistics
    if (localStorage.token) {
      this.$store.dispatch('survey/getIncompleteSurveysCount')
      if (this.loggedUser.role !== 'User') {
        this.$store.dispatch('location/getReportKPI')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/BaseTopNav.vue